import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "version"
};
import { getCode } from './utils/tools';
import { useStore } from '@/stores/main';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// eslint-disable-next-line no-undef
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup: function setup(__props) {
    var version = APP_VERSION;
    var _useStore = useStore(),
      code = _useStore.code;
    code.value = getCode() || code.value;
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(version)), 1)], 64);
    };
  }
});